<template>
  <div class="relative inline-flex items-center" @mouseenter="show" @mouseleave="hide">
    <slot name="trigger"></slot>
    <div
      v-if="isVisible"
      :class="[
        'absolute z-20 w-max max-w-xs p-3 rounded-lg shadow-lg',
        'bg-gray-900 text-white text-sm text-center',
        'transition-opacity duration-300',
        positionClasses,
      ]"
    >
      <slot name="content"></slot>
      <div :class="['absolute', arrowClasses]"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

const props = defineProps({
  position: {
    type: String,
    default: 'top', // 'top', 'bottom', 'left', 'right'
  },
});

const isVisible = ref(false);

const show = () => {
  isVisible.value = true;
};

const hide = () => {
  isVisible.value = false;
};

const positionClasses = computed(() => {
  switch (props.position) {
    case 'bottom':
      return 'top-full mt-2 left-1/2 -translate-x-1/2';
    case 'left':
      return 'right-full mr-2 top-1/2 -translate-y-1/2';
    case 'right':
      return 'left-full ml-2 top-1/2 -translate-y-1/2';
    default: // top
      return 'bottom-full mb-2 left-1/2 -translate-x-1/2';
  }
});

const arrowClasses = computed(() => {
  switch (props.position) {
    case 'bottom':
      return 'bottom-full left-1/2 -translate-x-1/2 border-x-8 border-x-transparent border-b-8 border-b-gray-900';
    case 'left':
      return 'left-full top-1/2 -translate-y-1/2 border-y-8 border-y-transparent border-l-8 border-l-gray-900';
    case 'right':
      return 'right-full top-1/2 -translate-y-1/2 border-y-8 border-y-transparent border-r-8 border-r-gray-900';
    default: // top
      return 'top-full left-1/2 -translate-x-1/2 border-x-8 border-x-transparent border-t-8 border-t-gray-900';
  }
});
</script>
